module.exports = __webpack_public_path__ + "static/media/excel-logo.8a321435.svg";